import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from "react";
import Head from 'next/head';
import GuideSlider from '@/components/slider/guide';
import { _postURL } from "@/api/index";
import _ from 'lodash';
import { Link } from "@/helpers/common_helper";
import { pagelink } from "@/config/site";
import Subscription from "@/components/section/subscription";
import { Breadcrumb } from '@/components/section/breadcrumb';
import { useRouter } from 'next/router';

export default function Index(props) {
    const { t } = props;
    const [sportsData, setSportsData] = useState([]);
    const [casinoData, setCasinoData] = useState([]);
    const [slotsData, setSlotsData] = useState([]);
    const [newsData, setNewsData] = useState([]);

    const currentPage = {
        pageName: t('Guide'),
        pageLink: useRouter().pathname
    };
    const previousPage = [{}];

    useEffect(async () => {
        try {
            let result = await _postURL("/api/guide");
            // console.log(result);
            if(!_.isEmpty(result.data)){
                setSportsData(result.data.sports);
                setCasinoData(result.data.casino);
                setSlotsData(result.data.slots);
                setNewsData(result.data.news);
            }
        }
        catch (error) {
            console.log(error);
        }
    }, []);

    return (
        <>
            <Head>
                <title>{t('Guide')}</title>
                <meta name="title" content=""></meta>
                <meta itemProp="title" content=""></meta>
                <meta property="og:title" content=""></meta>
                <meta name="description" content=""></meta>
                <meta itemProp="description" content=""></meta>
                <meta property="og:description" content=""></meta>
                <meta name="keywords" content=""></meta>
            </Head>

            <div className="page-content">
                <section className="guide-sec pt-5">
                    <div className="col-11 col-lg-9 mx-auto container">
                        <div className="row">
                            <div className="col-12">
                                <Breadcrumb 
                                    props={ props }
                                    currentPage={ currentPage }
                                    previousPage={ previousPage }
                                />
                                <div className="guide-inner">
                                    <div className="general-box">
                                        <h1>{t('Guide')}</h1>
                                        <p>Whether you are a pro or a total beginner, we have a complete casino guide for everything you 
                                            you need to know about the igaming industry, each of which is subjected to an in-depth review by 
                                            our industry-leading experts.</p>
                                    </div>
                                    {/* Sports */}
                                    <div className="guide-sport">
                                        <div className="guide-sport-text">
                                            <div className="media">
                                                <div className="guide-media-text">
                                                    <h2>{t('Sports')}</h2>
                                                    <img src="/assets/images/football.png" alt="" className="img-fluid" />
                                                </div>
                                                <Link href={pagelink.guide.sports}>{t('View All')}</Link>
                                            </div>
                                            <p>Online sports is expected to grow and would be something big in the future. And Ugrado will offer you
                                                everything you need to know before getting started to enter online sports.</p>
                                        </div>
                                        <GuideSlider type={'sports'} sliderData={sportsData}/>
                                    </div>
                                    {/* Casino */}
                                    <div className="guide-sport">
                                        <div className="guide-sport-text">
                                            <div className="media">
                                                <div className="guide-media-text">
                                                    <h2>{t('Casino')}</h2>
                                                    <img src="/assets/images/casino-chip.png" alt="" className="img-fluid" />
                                                </div>
                                                <Link href={pagelink.guide.casino}>{t('View All')}</Link>
                                            </div>
                                            <p>Ugrado will provide you with the tips and guides you need to know about Casino games. If you are
                                                new to the game, here is what you need to know before getting started.</p>
                                        </div>
                                        <GuideSlider type={'casino'} sliderData={casinoData}/>
                                    </div>
                                    {/* Slots */}
                                    <div className="guide-sport">
                                        <div className="guide-sport-text">
                                            <div className="media">
                                                <div className="guide-media-text">
                                                    <h2>{t('Slots')}</h2>
                                                    <img src="/assets/images/slots.png" alt="" className="img-fluid" />
                                                </div>
                                                <Link href={pagelink.guide.slots}>{t('View All')}</Link>
                                            </div>
                                            <p>Online slots are one of the very popular games in online casinos. There are a lot of different types of slot 
                                                casino games you would find in the online casinos, all with different kinds of themes, features and 
                                                designs. Ugrado will share with you the tips and guides for online slots, we've got everything you need 
                                                to know.</p>
                                        </div>
                                        <GuideSlider type={'slots'} sliderData={slotsData}/>
                                    </div>
                                    {/* News */}
                                    <div className="guide-sport">
                                        <div className="guide-sport-text">
                                            <div className="media">
                                                <div className="guide-media-text">
                                                    <h2>{t('News')}</h2>
                                                    <img src="/assets/images/news.png" alt="" className="img-fluid" />
                                                </div>
                                                <Link href={pagelink.guide.news}>{t('View All')}</Link>
                                            </div>
                                            <p>Explore what the igaming world is trending. Ugrado will bring you the latest trends and news in igaming 
                                            industry, online casinos, and much more.</p>
                                        </div>
                                        <GuideSlider type={'news'} sliderData={newsData}/>
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                                
                </section>
            </div>

            <br />

            {/** Subscription Part */}
            <Subscription {...props}/>
        </>
    )
}

export async function getStaticProps(data) {
    return {
        props: {
            ...(await serverSideTranslations(data.locale, ['common'])),
        },
    };
}